// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_o-6";
export var headerCell = "_o-2";
export var loadingStateContent = "_o-8";
export var rowWrapper = "_o-4";
export var stickyAggregationCell = "_o-b";
export var stickyAggregationRow = "_o-7";
export var stickyColumnCell = "_o-a";
export var stickyColumnHeaderCell = "_o-9";
export var table = "_o-1";
export var virtualRowWrapper = "_o-5";
export var virtualTableBodyFiller = "_o-d";
export var virtualTableBodyFillerBottom = "_o-e";
export var virtualTableContainer = "_o-0";
export var virtualTableContainerFill = "_o-c";
export var white = "_o-3";